module.exports = __webpack_public_path__ + "static/media/pig-orange.6fdbb4db.svg";